/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import log from '../../shared/utils/log';
class CaptureClicksV2 extends Component {
    static propTypes = {
        children: PropTypes.any,
        onClick: PropTypes.func,
        history: PropTypes.object,
        passingThroughClickHandler: PropTypes.func,
        interruptingClickHandler: PropTypes.func
    };

    onClick = (e) => {
        const { interruptingClickHandler, passingThroughClickHandler } = this.props;

        // invoke the tagged-along function if passed
        if (passingThroughClickHandler) {
            passingThroughClickHandler(e);
        }

        // interruptingClickHandler returns a truthy value to interrupt the event, falsy to apply default behavior
        log.info(`Intercepted onClick event.`);
        if (interruptingClickHandler) {
            const shouldProceed = !interruptingClickHandler(e);
            if (shouldProceed === false) {
                return;
            }
        }

        // Ignore canceled events, modified clicks, and right clicks.
        if (e.defaultPrevented) {
            return;
        }

        // We ignore any click that doesn't use the left button
        if (e.button !== 0) {
            return;
        }

        let currentElement = e.target;

        // goes up the DOM until the <a> element is found
        while (currentElement && currentElement.nodeName !== 'A') {
            currentElement = currentElement.parentNode;
        }

        // ignore if no <a> element was found
        if (!currentElement) {
            return false;
        }

        log.info(`Intercepted anchor tag.`);

        // Ignore the click if the element has a target.
        if (currentElement.target && currentElement.target !== '_self') {
            return;
        }

        // Ignore the click if it's a download link. (We use this method of
        // detecting the presence of the attribute for old IE versions.)
        if (currentElement.attributes.download) {
            return;
        }

        // Ignore hash (used often instead of javascript:void(0) in strict CSP envs)
        if (currentElement.getAttribute('href') === '#') {
            return;
        }

        // Use a regular expression to parse URLs instead of relying on the browser
        // to do it for us (because IE).
        const parser = document.createElement('a');
        parser.href = window.location.href;

        log.info(`protocol: ${currentElement.protocol}`);

        // Ignore links that don't use our ptotocol
        if (currentElement.protocol && currentElement.protocol !== parser.protocol) {
            return;
        }

        // Ignore 'rel="external"' links.
        if (currentElement.rel && /(?:^|\s+)external(?:\s+|$)/.test(currentElement.rel)) {
            return;
        }

        // Prevent :focus from sticking; preventDefault() stops blur in some browsers
        currentElement.blur();
        e.preventDefault();
        if (currentElement.pathname) {
            this.props.history.push(`${currentElement.pathname}${currentElement.search}`);
        }
    };

    render() {
        const { children, ...rest } = this.props;
        const props = { ...rest, onClick: this.onClick };
        delete props.staticContext;
        delete props.interruptingClickHandler;
        delete props.passingThroughClickHandler;
        return React.cloneElement(children, props);
    }
}

export default withRouter(CaptureClicksV2);
